export default __webpack_public_path__ + "c7106bfbd88c9a1285226cc3446084bf.png";